export default {
  Object: '对象',
  EditTheTagObject: '编辑位号对象',
  AddedATagObject: '新增位号对象',
  BasicProperties: '基本属性',
  Code: '代码',
  TheProjectName: '项目名称',
  Name: '名称',
  ParentObject: '上级对象',
  PleaseSelectAStatus: '请选择状态',
  ShortDescription: '短描述',
  LongDescription: '长描述',
  TemplateProperties: '模板属性',
  AssociationRelationships: '关联关系',
  DocumentName: '文档名称',
  SearchForEAMAssetCategories: '搜索EAMClass',
  FileName: '文件名称',
  SmartAssociations: '智能关联',
  ManualAssociation: '手动关联',
  DisRelation: '解除关联',
  WhetherToDisassociate: '是否解除关联关系',
  Disassociate: '解除关联关系',
  PleaseEnterAKeyword: '请输入关键字',
  ObjectHandover: '对象移交',
  Title: '标题',
  TheProcessType: '流程类型',
  ProcessStatus: '流程状态',
  Reviewer: '审核人',
  Deadline: '截止时间',
  SelectADatetime: '选择日期时间',
  UploadTime: '上传时间',
  Uploader: '上传人',
  BrowseForTagAsset: '浏览位号对象',
  SearchForAssetEncodingsAndAssetNames: '搜索对象编码和对象名称',
  SearchForAssetCategories: '搜索对象类别',
  RecursiveDisplay: '递归显示',
  Inquire: '查询',
  handOver: '移交',
  RuleImport: '规则导入',
  tree: '树',
  CorrelationModel: '关联模型',
  CreationTime: '创建时间',
  CreateAUser: '创建用户',
  LastModifiedTime: '最后修改时间',
  LastModifyTheUser: '最后修改用户',
  DownloadProgress: '下载进度',
  NotHandedOver: '未移交',
  UnderReview: '审核中',
  HandedOver: '已移交',
  TheModelIsAssociated: '已关联模型',
  ModelIsNotAssociated: '未关联模型',
  AssetHandoverProcess: '对象移交流程',
  PleaseFillInThisField: '请填写该字段',
  PleaseSelectACategory: '请选择类别',
  TagAssetImportResult: '标记对象导入结果',
  TagObjectTemplate: '位号对象模板',
  TheTagAssetExportFile: '位号对象导出文件',
  PleaseEnterATitle: '请输入标题',
  PleaseSelectAProcessType: '请选择流程类型',
  PleaseSelectADeadline: '请选择截止时间',
  ThereAreNoPermissionsToOperate: '没有权限操作',
  ThereIsanAssociatedRelationshipPleaseReselect: '存在已关联的关联关系，请重新选择',
  PleaseSelectTheFileYouWantToAssociate: '请选择要关联的文件',
  WhetherToDeleteTheCheckedData: '是否删除已勾选中的数据',
  DeleteSuccessful: '删除成功',
  CancelTheDeletion: '取消删除',
  PleaseSelectTheDataYouWantToDelete: '请选择要删除的数据',
  ConfirmThatYouWantToContinue: '请确认是否要继续',
  PleaseSelectAnObjectThatIsNotHandedOver: '请选择未移交的对象',
  DataOnObjectsThatAreUndeReviewAndTransferredHaveBeenAutomaticallyFiltered:
    '已自动过滤审核中和已移交的对象数据',
  In: '于',
  InitiationProcessObjectPublishingProcess: '发起流程【对象发布流程】',
  ReviewersCannotBeEmpty: '审核人不能为空',
  TheProcessHasBeenSubmitted: '流程已提交',
  TheProcessIsSaved: '流程已保存',
  ObjectHandoverManagement: '对象移交管理',
  ParentCategory: '上级类别',
  SearchForACategoryCodeOrCategoryName: '搜索类别代码或类别名称',
  NewCategories: '新增类别',
  ListView: '列表视图',
  TreeView: '树状视图',
  CategoryCode: '类别代码',
  CategoryName: '类别名称',
  ParentCategory: '上级类别',
  Icon: '图标',
  EditTheTagCategory: '编辑位号类别',
  AddedTagCategories: '新增位号类别',
  TheTag: '位号',
  PropertyTemplates: '属性模板',
  NoPropertyTemplateIsAssociated: '未关联属性模板',
  ThePropertyTemplateHasBeenAssociated: '已关联属性模板',
  PleaseEnterAPropertyTemplate: '请输入属性模板',
  CategoryHierarchy: '类别层级',
  Inquire: '查询',
  CategoryDetails: '类别明细',
  CategoryAssociations: '类别关联',
  AssociateaDocumentCategory: '关联文档类别',
  ADocumentCategoryHasBeenAssociated: '已关联文档类别',
  TagCategoryTemplate: '位号类别模板',
  TagCategoryImportResults: '位号类别导入结果',
  TagCategoryExportFile: '位号类别导出文件',
  ExportFailed: '导出失败',
  NoRecordsAreCurrentlySelectedTheSystemWillExportAlltheDataintheSystembyDefaulttheOperationWillTakeaLongTimePleaseConfirmWhetherYouWanttoContinue:
    '当前没有选中任何记录,系统将默认导出系统中所有数据,该操作时间会比较长,请确认是否要继续?',
  TagCategoryManagement: '位号类别管理',
  TheOrdinalNumberCannotbeEmpty: '序号不能为空',
  TheLengthCannotExceedCharacters: '长度不能超过10个字符',
  TheOrdinalNumberMustbeaPositiveIntegerGreaterThan: '序号必须为大于0的正整数',
  DoYouWanttoConfirmDisassociationFromtheTagIfConfirmedtheCategoryforThatTagWillbeCleared:
    '是否确认解除与该位号的关联关系？若确认，将清空该位号的类别',
  PleaseFillinTheCategoryCode: '请填写类别代码',
  PleaseFillinTheCategoryName: '请填写类别名称',
  EdittheAssociationRelationship: '编辑关联关系',
  PleaseSelectanAssetEncoding: '请选择对象编码',
  PleaseSelectaDocumentName: '请选择文档名称',
  PleaseSelectaFileName: '请选择文件名称',
  RefineYourSearch: '精确搜索',
  ParentEncoding: '上级编码',
  AncestorName: '上级名称',
  AssociateaDocument: '关联文档',
  TheAssetEncodingCannotbeEmpty: '对象编码不能为空',
  TheFileNameCannotbeEmpty: '文件名称不能为空',
  AddSuccess: '新增成功',
  PleaseFollowthePromptstoFillintheCorrectForm: '请按提示正确填写',
  WhethertoDeletetheSelectedData: '是否删除选中的数据',
  AssetDataManagement: '对象数据管理',
}
